import { render } from "./MobiPointsWallet.vue?vue&type=template&id=9f1092ca&scoped=true&ts=true"
import script from "./MobiPointsWallet.vue?vue&type=script&lang=ts"
export * from "./MobiPointsWallet.vue?vue&type=script&lang=ts"

import "./MobiPointsWallet.vue?vue&type=style&index=0&id=9f1092ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1092ca"]])

export default __exports__